import { useEffect } from "react";

const useRichTextEditorBlurOnScroll = () => {
  useEffect(() => {
    const handleRichTextEditorScroll = () => {
      const active = document.activeElement as HTMLElement | null;

      // Blur only rich-text editors (Quill)
      if (active?.classList.contains("ql-editor")) {
        active.blur();
        window.getSelection()?.removeAllRanges();
      }
    };

    window.addEventListener("scroll", handleRichTextEditorScroll, {
      passive: true,
    });
    return () =>
      window.removeEventListener("scroll", handleRichTextEditorScroll);
  }, []);
};

export default useRichTextEditorBlurOnScroll;
